class HorizontalScroll {
  sideScroll(element: HTMLElement, step: number) {
    element.scrollLeft += step;
  }
}

const horizontalScrollUtil = new HorizontalScroll();
export { horizontalScrollUtil };
